export const hospitality = [
  {
    id: 7001,
    title: "Event Planning",
    shortTitle: "event",
    service: "hospitality",
    description: "From weddings to corporate gatherings, our event planning services ensure every detail is perfect. We work closely with clients to create memorable experiences tailored to their needs.",
    price: "Request",
    image: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/event.jpg',

    imageWebp: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/event.webp',

    imageAvif: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/event.avif',


    thumbnail: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/event-thumb.jpg',


    thumbnailWebp: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/event-thumb.webp',


    thumbnailAvif: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/event-thumb.avif',
    category: "event",
    subtitle: "Events",
    features: [
      {
        title: "Venue Selection",
        description: "We scout and secure the perfect venue for your occasion, from intimate spaces to grand ballrooms."
      },
      {
        title: "Catering Coordination",
        description: "Custom menus, dietary accommodations, and professional service staff tailored to your event."
      },
      {
        title: "Entertainment & Decor",
        description: "From floral arrangements to entertainment, we bring your vision to life with meticulous attention to detail."
      }
    ],
    sections: [
      {
        subtitle: "Our Promise",
        title: "Your event, our expertise.",
        description: "Let us handle the logistics while you enjoy the celebration. Weddings, birthdays, anniversaries, and corporate gatherings."
      }
    ],
    stats: [
      { value: "500+", label: "Events" },
      { value: "98%", label: "Client satisfaction" },
      { value: "15+", label: "Years experience" }
    ]
  },
  {
    id: 7002,
    title: "Catering",
    shortTitle: "catering",
    service: "hospitality",
    description: "Professional catering services for events of all sizes. We provide delicious meals, snacks, and beverages tailored to your event's needs and preferences.",
    price: "Request",
    image: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/catering.jpg',

    imageWebp: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/catering.webp',

    imageAvif: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/catering.avif',


    thumbnail: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/catering-thumb.jpg',


    thumbnailWebp: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/catering-thumb.webp',


    thumbnailAvif: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/catering-thumb.avif',
    category: "catering",
    subtitle: "Food & Beverage",
    features: [
      {
        title: "Custom Menu Planning",
        description: "Tailored menus for brunch, lunch, dinner, or all-day events. Dietary accommodations available."
      },
      {
        title: "Event Coordination",
        description: "Professional service staff, setup, and cleanup so you can focus on your guests."
      },
      {
        title: "Flexible Service Styles",
        description: "Plated, buffet, station-style, or cocktail reception—we adapt to your vision."
      }
    ],
    sections: [
      {
        subtitle: "Meals",
        title: "Brunch to dinner.",
        description: "Breakfast, lunch, dinner, snacks, and drinks. Custom options for every occasion."
      }
    ],
    stats: [
      { value: "1K+", label: "Events catered" },
      { value: "100+", label: "Menu options" },
      { value: "24/7", label: "Coordination support" }
    ]
  },
  {
    id: 7003,
    title: "Stay",
    shortTitle: "stay",
    service: "hospitality",
    description: "Your home away from home. We ensure a comfortable and memorable stay with personalized service and attention to detail.",
    price: "Request",
    image: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/stay.jpg',

    imageWebp: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/stay.webp',

    imageAvif: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/stay.avif',


    thumbnail: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/stay-thumb.jpg',


    thumbnailWebp: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/stay-thumb.webp',


    thumbnailAvif: (process.env.PUBLIC_URL || '') + '/assets/images/hospitality/stay-thumb.avif',
    category: "stay",
    subtitle: "Accommodations",
    features: [
      {
        title: "Premium Rooms & Suites",
        description: "Standard rooms, deluxe suites, executive rooms, and family accommodations for every need."
      },
      {
        title: "Full Amenities",
        description: "Complimentary Wi-Fi, room service, concierge, fitness center, business center, and more."
      },
      {
        title: "24/7 Support",
        description: "Front desk, housekeeping, wake-up calls, luggage storage, and airport transfers on request."
      }
    ],
    sections: [
      {
        subtitle: "Check-in",
        title: "3:00 PM check-in, 11:00 AM check-out.",
        description: "Flexible cancellation policy available. Extended stay options for longer visits."
      }
    ],
    stats: [
      { value: "4.9", label: "Guest rating" },
      { value: "1-6", label: "Guests Capacity" },
      { value: "24/7", label: "Concierge" }
    ]
  }
];
